<template>
<div class="p-2">
    <div class="form-row">
        <div class="mui-textfield col-6">
            <span class="textfield">{{ plan.display_name }}</span>
            <label>Display Name</label>
        </div>
        <div class="mui-textfield col-6">
            <span class="textfield">{{ plan.plan_type_pretty }}</span>
            <label>Plan Type</label>
        </div>
    </div>

    <div class="form-row">
        <div class="mui-textfield col-6">
            <span class="textfield">{{ plan.accrual_year_pretty }}</span>
            <label>Accrual Year Type</label>
        </div>
        <div class="mui-textfield col-6">
            <span class="textfield">{{ plan.state_pretty || '-' }}</span>
            <label>State</label>
        </div>
    </div>

    <div class="form-row">
        <div class="mui-textfield col-6">
            <span class="textfield">{{ plan.method_pretty }}</span>
            <label>Accrual Method</label>
        </div>
        <div class="mui-textfield col-6">
            <span class="textfield">{{ eligibility }}</span>
            <label>Eligibility</label>
        </div>
    </div>

    <div class="form-row">
        <div class="mui-textfield col-6">
            <span class="textfield">{{ plan.eligible_hired_on_or_after ? $filters.date(plan.eligible_hired_on_or_after) : 'Any date' }}</span>
            <label>Hired On or After</label>
        </div>
    </div>

    <h4 class="theading mb-2">Termination and Rehire</h4>
    <div class="form-row">
        <div class="mui-textfield col-6">
            <span class="textfield">{{ plan.rehire_window_days }} days</span>
            <label>Rehire Window</label>
        </div>
        <div class="mui-textfield col-6">
            <span class="textfield">{{ plan.payout_on_termination ? 'Yes' : 'No' }}</span>
            <label>Pay Out on Termination</label>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['plan', ],
    computed: {
        eligibility() {
            const parts = []
            if (this.plan.eligible_employment != 'both') {
                parts.push(this.plan.eligible_employment_pretty)
            }
            if (this.plan.eligible_compensation != 'both') {
                parts.push(this.plan.eligible_compensation_pretty)
            }
            return parts.length ? parts.join(', ') : 'All employees'
        },
    },
}
</script>
